import { render, staticRenderFns } from "./CreateGroupTest.vue?vue&type=template&id=3fcfe6fc"
import script from "./CreateGroupTest.vue?vue&type=script&lang=js"
export * from "./CreateGroupTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports